import { QueryClient } from '@tanstack/react-query';
import { useAuthStore } from 'state/store/auth/useAuthStore';

type NavigateFn = (to: string, options?: { replace?: boolean }) => void;

/* Same for every user. Removing them makes NoAuthMiddleware and the login page
   refetch, and each shows the full-screen loader until they are back. */
const KEEP_AFTER_LOGOUT = ['getConfigurationSettings', 'loginOption'];

/**
 * Clears auth, routes to login, then wipes the React Query cache after React
 * has applied logout (so authenticated observers are already disabled/unmounted).
 * Clearing synchronously while observers still have enabled:true refetches
 * /iam/me and flashes LoadingOverlay.
 */
export function completeLogout(queryClient: QueryClient, navigate: NavigateFn) {
  useAuthStore.getState().logout();
  navigate('/login', { replace: true });
  queueMicrotask(() => {
    queryClient.removeQueries({
      predicate: (query) => !KEEP_AFTER_LOGOUT.includes(String(query.queryKey[0])),
    });
    queryClient.getMutationCache().clear();
  });
}
